import React from 'react';
import {
  Image, View,
} from 'react-native-web';
import {
  img_chat_ios,
  img_imsg_text_field, img_imsg_toolbar,
  img_scr_onboarding_03_a_ios,
} from '../../../../utils/ImagesManagementUtils';
import BottomSquareCard from '../../AuxiliaryComponent/MixComponent/BottomSquareCard';
import { Android } from '../../../../utils/DictionaryManagementUtils';
import { getRef } from '../../../../utils/Utils';

//= ========================================================================

const IMsgExpandTextsFP = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => {
  const isAnd = false;
  const { colors } = globJSON.configurations.theme;

  const myStyles = {
    phoneImage: {
      width: 240,
      height: isAnd ? 427 : 520,
      marginTop: 30,
      position: 'absolute',
      backgroundColor: colors.app_background_color,
    },
    bankLogo: {
      width: 67,
      height: 35,
      marginLeft: 23,
      marginTop: isAnd ? 222 - 80 : 222,
      position: 'absolute',
    },
    imsg: {
      resize: 'cover',
      height: 224,
      marginTop: 305,
      width: 240,
    },
    iMsgBankLogo: {
      height: 22,
      marginLeft: 147,
      marginTop: 352,
      width: 29,
      background: 'white',
      borderRadius: 10,
    },
  };

  return (
    <View style={{ width: 240, height: simPlatform === Android ? 457 : 550 }} ref={getRef(slideshowRefs)}>
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={img_scr_onboarding_03_a_ios}
      />
      <Image
        fadeDuration={0}
        style={[myStyles.phoneImage, myStyles.imsg, { marginTop: 347 }]}
        source={img_imsg_toolbar}
      />
      <Image
        fadeDuration={0}
        style={[myStyles.phoneImage, myStyles.imsg, { height: 24, marginTop: 323 }]}
        source={img_imsg_text_field}
      />
      <Image
        fadeDuration={0}
        style={[myStyles.phoneImage, myStyles.imsg, { height: 100, marginTop: 175 }]}
        source={img_chat_ios}
      />
      {globJSON.configurations.services.menu.iMsg_bank_logo.fUri && (
      <Image
        style={myStyles.iMsgBankLogo}
        source={globJSON.configurations.services.menu.iMsg_bank_logo.fUri}
      />
      )}
      <BottomSquareCard
        globJSON={globJSON}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
    </View>
  );
};

export default IMsgExpandTextsFP;
